import HttpClientXml from "../utils/HttpClientXml";

const login = async (data) => {
  let endPoint = "login";
  return HttpClientXml.post(endPoint, data);
};

const sendOTPtoEmail = async (data) => {
  // console.log("register data", data);
  let endPoint = "register";
  return HttpClientXml.post(endPoint, data);
};

const verifyOTP = async (data) => {
  let endPoint = "verify-otp";
  return HttpClientXml.post(endPoint, data);
};

const registerAccount = async (data) => {
  let endPoint = "update";
  return HttpClientXml.put(endPoint, data);
};

export default {
  registerAccount,
  verifyOTP,
  sendOTPtoEmail,
  login,
};
